import React from "react";
import { Theme } from "@literati/public-ui-shared-react";
import { Step } from "components/Step/stepTypes";

export interface StepFlowProps<State> {
  className?: string;
  currentSlug: StepFlowProps<State>["steps"][number]["slug"];
  state: State;
  steps: Step<State>[];
}

export function StepFlow<State>({
  currentSlug,
  state,
  steps,
}: StepFlowProps<State>) {
  return (
    <Theme>
      {steps.map((step, idx) => {
        const Component = step.component;
        return step.slug === currentSlug ? (
          <Component key={`step-component-${idx}`} {...state} />
        ) : null;
      })}
    </Theme>
  );
}

export default StepFlow;
